import { useState } from "react";
import { useAuth } from "@shared";
import { AccountForm } from "@accounts/forms/AccountForm";
import { ProfilePictureUpload } from "@profile";
import { Badge, Button } from "@printtat/ui";
import { UserRound } from "lucide-react";

export const AccountSettings = () => {
  const { user, refreshUser } = useAuth();
  const [isEditing, setIsEditing] = useState(false);

  if (!user) {
    return null;
  }

  const handleUploadSuccess = () => {
    refreshUser();
  };

  const handleDeleteSuccess = () => {
    refreshUser();
  };

  return (
    <div className="space-y-6">
      {/* Profile Header — avatar + name + role */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <div className="flex items-center gap-2 mb-5">
          <UserRound className="w-4 h-4 text-gray-700" />
          <h2 className="text-sm font-semibold text-gray-900">Profile</h2>
        </div>

        <div className="flex items-center gap-5">
          <ProfilePictureUpload
            user={user}
            currentPicture={user.profilePicture}
            onUploadSuccess={handleUploadSuccess}
            onDeleteSuccess={handleDeleteSuccess}
            compact
          />

          <div className="flex-1 min-w-0">
            <h3 className="text-base font-semibold text-gray-900">
              {user.firstName && user.lastName
                ? `${user.firstName} ${user.lastName}`
                : user.email}
            </h3>
            <p className="text-sm text-gray-500 mt-0.5">{user.email}</p>
            <div className="flex items-center gap-2 mt-2">
              <Badge color="blue" variant="soft">
                <span className="capitalize">{user.role}</span>
              </Badge>
              <Badge
                color={user.isVerified ? "green" : "yellow"}
                variant="soft"
              >
                {user.isVerified ? "Verified" : "Pending Verification"}
              </Badge>
            </div>
          </div>
        </div>
      </div>

      {/* Account Details */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-sm font-semibold text-gray-900">
            Account Details
          </h2>
          <Button
            variant={isEditing ? "outline" : "solid"}
            size="sm"
            color="dark"
            onClick={() => setIsEditing(!isEditing)}
          >
            {isEditing ? "Cancel" : "Edit Profile"}
          </Button>
        </div>

        <AccountForm
          user={user}
          isEditing={isEditing}
          onEditComplete={() => setIsEditing(false)}
        />
      </div>
    </div>
  );
};
